export const getImageUrl = (org) => {
    let url = `https://daraz-clone.onrender.com/imageStream/${org}`
    return url
}